/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-produced-content/doc-viewer-produced-content.component.scss */
:host {
  height: 100%;
}
iframe {
  flex: auto;
  border: 0px;
}
.disable-mouse-events {
  pointer-events: none;
}
/*# sourceMappingURL=doc-viewer-produced-content.component.css.map */
